<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_monthlyVat"
      :custom="{ storage: true }"
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('monthlyVat_list')" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('monthlyVat_regenerate')"
          @click="funRegenerate"
        >
          重新生成
        </el-button>
        <el-button
          v-if="getLimit('monthlyVat_pushBatch')"
          @click="funPushBatch"
        >
          批量推送
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      class="mytable-style"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="declarationMonth"
          title="申报月份"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.declarationMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="申报月份"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="实际承运人手机号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="incomeAmount"
          title="计税依据"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.incomeAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.incomeAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxAmount"
          title="应纳税额"
          min-width="240"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCount"
          title="运单数"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.orderCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.orderCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="状态"
          min-width="130"
          :formatter="({ cellValue }) => formatterStatus(cellValue)"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" placeholder="请选择" clearable>
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="failureMessage"
          title="失败原因"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.failureMessage"
            placeholder="请输入失败原因"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pushedAt"
          title="推送时间"
          min-width="230"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.pushedAtRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'pushedAt')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('monthlyVat_push') && scope.row.status !== 'SUCCESS'"
            class="item"
            effect="dark"
            content="推送"
            placement="top"
          >
            <vxe-button type="text" @click="funPush(scope.row.id)">
              <em class="el-icon-upload2" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import pageMixin from "@/mixins/pageMixin";
import {
  vatList,
  vatRegenerate,
  vatPush,
  vatPushBatch
} from "@/api/MonthlyTax";

export default {
  name: "MonthlyVatReport",
  mixins: [pageMixin],
  data() {
    return {
      loading: false,
      tableData: [],
      statusOptions: [
        { value: "PENDING", label: "未推送" },
        { value: "PUSHING", label: "推送中" },
        { value: "SUCCESS", label: "推送成功" },
        { value: "FAILED", label: "推送失败" }
      ],
      listQuery: {
        declarationMonth: "",
        driverName: "",
        driverPhone: "",
        incomeAmountStart: "",
        incomeAmountEnd: "",
        taxAmountStart: "",
        taxAmountEnd: "",
        orderCountStart: "",
        orderCountEnd: "",
        status: "",
        failureMessage: "",
        pushedAtStart: "",
        pushedAtEnd: "",
        pushedAtRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    formatterStatus(cellValue) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    findList() {
      this.loading = true;
      return vatList(this.listQuery)
        .then(res => {
          this.tableData = res.data.records;
          this.listQuery.total = res.data.total;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 按申报月份重新生成
    funRegenerate() {
      if (!this.listQuery.declarationMonth) {
        this.$message.warning("请先选择申报月份");
        return;
      }
      this.$confirm(
        `确认重新生成 ${
          this.listQuery.declarationMonth
        } 的增值税申报数据吗？推送成功的记录将保留且不可修改。`,
        "提示",
        { type: "warning" }
      )
        .then(async () => {
          const rLoading = this.openLoading();
          try {
            const res = await vatRegenerate(this.listQuery.declarationMonth);
            const data = res.data || {};
            this.$message.success(
              `重新生成完成：成功 ${data.vatSuccess ||
                0} 条，跳过 ${data.vatSkipped || 0} 条，异常 ${data.vatFailed ||
                0} 条`
            );
          } catch (e) {
            // 拦截器已提示
          } finally {
            rLoading.close();
            this.findList();
          }
        })
        .catch(() => {});
    },
    // 单条推送
    async funPush(id) {
      const rLoading = this.openLoading();
      try {
        const res = await vatPush(id);
        this.$message.success(res.msg || "推送成功");
      } catch (e) {
        // 拦截器已提示
      } finally {
        rLoading.close();
        this.findList();
      }
    },
    // 批量推送
    funPushBatch() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (!selectRecords || selectRecords.length === 0) {
        this.$message.warning("请先勾选需要推送的记录");
        return;
      }
      const ids = selectRecords.map(item => item.id).join(",");
      this.$confirm(
        `确认推送选中的 ${selectRecords.length} 条记录吗？`,
        "提示",
        { type: "warning" }
      )
        .then(async () => {
          const rLoading = this.openLoading();
          try {
            const res = await vatPushBatch(ids);
            this.$message.success(`批量推送完成，成功 ${res.data || 0} 条`);
          } catch (e) {
            // 拦截器已提示
          } finally {
            rLoading.close();
            this.$refs.xTable.clearCheckboxRow();
            this.findList();
          }
        })
        .catch(() => {});
    }
  }
};
</script>
